<template>
  <!-- Default form register -->
  <form>
    <div class="container">
      <br />
      <p class="h4 text-center mb-4">{{titel}}</p>
    </div>

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Username</span>
      </div>
      <input aria-label="Username" id="username" class="form-control" v-model="client.username" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Nombre</span>
      </div>
      <input aria-label="First name" id="name" class="form-control" v-model="client.name" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Apellido</span>
      </div>
      <input aria-label="Last name" id="lastName" class="form-control" v-model="client.last_name" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Email</span>
      </div>
      <input
        type="email"
        aria-label="First name"
        id="email"
        class="form-control"
        v-model="client.email"
      />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Telefono</span>
      </div>
      <input aria-label="Password" class="form-control" v-model="client.tel" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Banco</span>
      </div>
      <input aria-label="Password" class="form-control" v-model="client.bco" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Cta Banco</span>
      </div>
      <input aria-label="Password" class="form-control" v-model="client.bco_account" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Moneda</span>
      </div>
      <input aria-label="Moneda" class="form-control" v-model="client.coin" />
    </div>

    <br />

    <div class="input-group input-group-sm">
      <div class="input-group-prepend">
        <span class="input-group-text">Pais</span>
      </div>
      <input aria-label="Pais" class="form-control" v-model="client.country" />
    </div>

    <br />

    <div class="input-group">
      <div class="input-group-prepend">
        <span class="input-group-text">Adicional</span>
      </div>
      <b-form-textarea id="textarea" v-model="client.comentario" rows="1"></b-form-textarea>
    </div>

    <br />

    <div v-show="this.update">
      <button type="button" class="btn btn-success btn-block" @click="editar(client)">Guardar</button>
      <button
        type="button"
        class="btn btn-danger btn-block"
        @click="eliminar(client.client_id)"
      >Borrar</button>
      <!--button type="button" class="btn btn-success" @click="nuevo">Nuevo</button-->
    </div>

    <div v-show="!this.update">
      <button type="button" class="btn btn-success btn-lg btn-block" @click="agregar">Agregar</button>
    </div>
    <div>
      <b-button size="sm" class="float-right" variant="warning" block @click="cancel">Cancel</b-button>
    </div>
  </form>
  <!-- Default form register -->
</template>

<script>
import {
  createNewClient,
  editClient,
  deleteClient
} from "./../../api/conection";
export default {
  name: "clientForm",
  props: {
    client: {
      type: Object,
      default: {}
    },
    update: false
  },
  data() {
    return {
      titel: "Formulario de Clientes"
    };
  },
  computed: {},
  methods: {
    agregar() {
      let {
        name,
        last_name,
        email,
        tel,
        bco,
        bco_account,
        coin,
        country,
        username,
        comentario
      } = this.client;
      const body = {
        name,
        last_name,
        email,
        tel,
        bco,
        bco_account,
        coin,
        country,
        username,
        comentario
      };
      createNewClient(body)
        .then(response => {
          if (response.status === 201) {
            body.client_id = response.body.client_id;
            this.$store.dispatch("addClientAction", body);
          }
          this.$bvModal.hide("my-client-modal");
          /* limpio formulario */
          this.nuevo();          
        })
        .catch(err => {
          console.log(err);
          /* limpio formulario */
          this.nuevo();
        });
    },
    editar(cli) {
      const id = cli.client_id;
      editClient(cli, id)
        .then(response => {
          //console.log(response);          
          if (response.status === 200) {            
            this.$store.dispatch("updateClientAction", cli);
            /* limpio formulario */
            this.nuevo();
            this.$bvModal.hide("my-client-modal");
          }          
        })
        .catch(err => {
          console.log(err);
          /* limpio formulario */
          this.nuevo();
        });
    },
    eliminar(cli_id) {
      if (confirm("Está seguro que quiere borrar Este cliente ?")) {
        deleteClient(cli_id)
          .then(response => {
            if (response.status === 200) {
              this.$store.dispatch("deleteClientAction", cli_id);              
            }
            /* limpio formulario */
            this.nuevo();
            this.$bvModal.hide("my-client-modal");
          })
          .catch(err => {
            console.log(err);
            /* limpio formulario */
            this.nuevo();
          });
      }
    },
    nuevo() {
      this.$store.dispatch("unSelectClientAction", {});
    },
    cancel() {
      this.$store.dispatch("unSelectClientAction", {});
      this.$bvModal.hide("my-client-modal");
    }
  }
};
</script>

<style>
.input-group-prepend {
  width: 85px;
}
form {
  padding: 15px;
}
</style>